import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Landing from "./view/Landing";
import Signup from "./view/Signup";
import Login from "./view/Login";
import InvoiceCreate from "./view/InvoiceCreate";
import InvoiceSearch from "./view/InvoiceSearch";
import Profile from "./view/Profile";
import Sells from "./view/Sells";
import StockSearch from "./view/StockSearch";
import StockCreate from "./view/StockCreate";
import StockUpdate from "./view/StockUpdate";
import Payment from "./view/Payment";
import OrderError from "./errorview/OrderError";
import Audit from "./view/Audit";
import Report from "./view/Report";
import BillGenerate from "./view/BillGenerate";
import DistributorSearch from "./view/DistributorSearch";
import DistributorCreate from "./view/DistributorCreate";
import DistributorBillSearch from "./view/DistributorBillSearch";
import DistributorBillCreate from "./view/DistributorBillCreate";
import Home from "./view/Home";
import ProductCategory from "./view/ProductCategory";
import PendingPayments from "./view/PendingPayments";
import ReturnSearch from "./view/ReturnSearch";
import CustomerPage from "./view/CustomerPage";
import PrintLabels from "./view/PrintLabels";
import Product from "./view/Product";
import DashboardSettings from "./view/DashboardSettings";
import ProductSalesReport from "./view/ProductSalesReport";
import GstReport from "./view/GstReport";
import AdminPanel from "./view/AdminPanel";
import OfferCreate from "./view/OfferCreate";
import OfferSearch from "./view/OfferSearch";
import WhatsAppConnect from "./view/WhatsAppConnect";
import ProtectedRoute from "./utils/ProtectedRoute";
import ChatWidget from "./components/ChatWidget";

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* ✅ Protected routes */}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice"
          element={
            <ProtectedRoute>
              <InvoiceCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice/search"
          element={
            <ProtectedRoute>
              <InvoiceSearch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sells"
          element={
            <ProtectedRoute>
              <Sells />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stock/search"
          element={
            <ProtectedRoute>
              <StockSearch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stock/update"
          element={
            <ProtectedRoute>
              <StockUpdate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stock/create"
          element={
            <ProtectedRoute>
              <StockCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/audit"
          element={
            <ProtectedRoute>
              <Audit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report"
          element={
            <ProtectedRoute>
              <Report />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bill"
          element={
            <ProtectedRoute>
              <BillGenerate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor/search"
          element={
            <ProtectedRoute>
              <DistributorSearch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor/create"
          element={
            <ProtectedRoute>
              <DistributorCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor/bill/search"
          element={
            <ProtectedRoute>
              <DistributorBillSearch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/distributor/bill/create"
          element={
            <ProtectedRoute>
              <DistributorBillCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment"
          element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/product-category"
          element={
            <ProtectedRoute>
              <ProductCategory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <ProtectedRoute>
              <CustomerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments/pending"
          element={
            <ProtectedRoute>
              <PendingPayments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/returns"
          element={
            <ProtectedRoute>
              <ReturnSearch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stock/print-labels"
          element={
            <ProtectedRoute>
              <PrintLabels />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/product"
          element={
            <ProtectedRoute>
              <Product />
            </ProtectedRoute>
          }
        />
        <Route
          path="/master/settings"
          element={
            <ProtectedRoute>
              <DashboardSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ordererror"
          element={
            <ProtectedRoute>
              <OrderError />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report/gst"
          element={
            <ProtectedRoute>
              <GstReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report/product-sales"
          element={
            <ProtectedRoute>
              <ProductSalesReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/offers/create"
          element={
            <ProtectedRoute>
              <OfferCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/offers/search"
          element={
            <ProtectedRoute>
              <OfferSearch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/offers/whatsapp-connect"
          element={
            <ProtectedRoute>
              <WhatsAppConnect />
            </ProtectedRoute>
          }
        />
      </Routes>

      {/* Floating AI assistant — self-hides when the user is not logged in */}
      <ChatWidget />
    </Router>
  );
}

export default App;
